export interface ClientAddress {
  address: string
  city: string
  state: string
  zip: string
}

export const EMPTY_CLIENT_ADDRESS: ClientAddress = { address: '', city: '', state: '', zip: '' }

/**
 * The subset of a client's address the user actually changed, or null if
 * nothing did.
 *
 * Editing a client's address in the estimate wizard writes the shared Client
 * record, so the PUT is skipped entirely when nothing changed. A field the user
 * cleared is returned as `''` rather than omitted — omitting it would silently
 * keep the old value on the server.
 */
export function diffClientAddress(
  loaded: ClientAddress,
  current: ClientAddress,
): Partial<ClientAddress> | null {
  const changes: Partial<ClientAddress> = {}
  const keys: (keyof ClientAddress)[] = ['address', 'city', 'state', 'zip']

  for (const key of keys) {
    const next = (current[key] ?? '').trim()
    const prev = (loaded[key] ?? '').trim()
    if (next !== prev) changes[key] = next
  }

  return Object.keys(changes).length > 0 ? changes : null
}
